module.exports = __webpack_public_path__ + "img/p07.cc82acc3.png";